import store from '@/store'
import { getToken } from '@/utils/auth'
import axios from 'axios'
import Cookies from 'js-cookie'
import { Message, MessageBox } from 'element-ui'
import qs from 'qs'

//create an axios instance
console.log(
  'process.env.NODE_ENV: ',
  process.env.NODE_ENV,
  process.env.VUE_APP_BASE_API
)
const service = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development'
      ? `http://127.0.0.1:8999` + process.env.VUE_APP_BASE_API
      : `https://meet.haohome.top` + process.env.VUE_APP_BASE_API, //url = base url + request url
  //baseURL: `https://hdlapi.utools.club` + process.env.VUE_APP_BASE_API, // url = base url + request url
  //withCredentials: true, // send cookies when cross-domain requests
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  timeout: 60000, //request timeout
  transformRequest: [
    function(data, headers) {
      if (data instanceof FormData) {
        return data
      } else {
        return qs.stringify(data)
      }
    }
  ]
})
//request interceptor
service.interceptors.request.use(
  config => {
    //do something before request is sent
    if (store.getters.token) {
      config.headers['X-Token'] = getToken()
      const uid = Cookies.get('uid')
      if (uid) {
        config.headers['X-User-Id'] = uid
      }
    }
    if (config.responseType === 'arraybuffer') {
      config.timeout = 500000
    }
    return config
  },
  error => {
    console.log('error: ', error)
    return Promise.reject(error)
  }
)

//response interceptor
service.interceptors.response.use(
  response => {
    if (response.config.responseType === 'arraybuffer') {
      return response
    }
    const res = response.data
    //if the custom code is not 200, it is judged as an error.
    if (res.code !== 200) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      //50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        //to re-login
        MessageBox.confirm('您已退出登录', 'Confirm logout', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) //for debug
    let msg = error.message
    if (error.message.includes('timeout')) {
      //判断请求异常信息中是否含有超时timeout字符串
      msg = '请求数据超时' //reject这个错误信息
    }
    Message({
      message: msg,
      type: 'error',
      duration: 5 * 1000
    })
    msg = null
    return Promise.reject(error)
  }
)

export default service
